import useKeyBoardListener from './useKeyboardListener';
import { useEffect, useRef, useState } from 'react';

const allowedKeys = 'abcdefghijklmnopqrsutvwxyz0123456789-*/=';

const useBarcodeScanner = () => {
  const [tray, setTray] = useState('');

  const clearTray = () => {
    setTray('');
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (tray) {
        clearTray();
      }
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [tray]);

  const currentState = useRef(tray);
  currentState.current = tray;

  const handler = (key) => {
    const actualKey = key.key.toLowerCase();
    if (actualKey.length === 1 && allowedKeys.includes(actualKey)) {
      setTray((prev) => {
        return prev + actualKey;
      });
    }
  };
  useKeyBoardListener(handler);

  return {
    tray, clearTray,
  };
};

export default useBarcodeScanner;
